'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const react = require('@emotion/react');
const designSystem = require('@zapier/design-system');

const styles = react.css(Object.assign(Object.assign({}, designSystem.Typography.SmallPrint1), { color: designSystem.Colors.GrayWarm9, textTransform: "lowercase", "&::before": {
  content: '"("'
}, "&::after": {
  content: '")"'
}, '&[data-state="disabled"]': {
  color: designSystem.Colors.GrayWarm5
} }));
const LabelRequiredText = ({ children, isDisabled }) => {
  return (
    // `aria-hidden` to prevent it from being read redundantly.
    // The associated `input` field should indicate whether it's
    // required to screenreaders.
    react.jsx("span", { "aria-hidden": "true", css: styles, "data-state": isDisabled ? "disabled" : void 0, "data-zds": true }, children)
  );
};

exports.LabelRequiredText = LabelRequiredText;
//# sourceMappingURL=LabelRequiredText.cjs.js.map
